module.exports = __webpack_public_path__ + "static/media/sopt23kz.734bdc2f.pdf";